import { RootState } from "../../rootReducer";

export const selectIsSavingMentalCheck = (state: RootState) =>
  state.newMentalCheck.loading;
export const selectIsSaved = (state: RootState) => state.newMentalCheck.saved;
export const selectSaveErrorMessage = (state: RootState) =>
  state.newMentalCheck.error;
export const NewMentalCheckDataResponse = (state: RootState) =>
  state.newMentalCheck.newMentalCheckResponse;
